import loadable from "@loadable/component";
import { useParams } from "react-router";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditVehicleCategoryComponent = loadable(
  () => import("../../components/VehicleCategory/EditVehicleCategory")
);
const EditVehicleCategory = () => {
  const { id } = useParams();

  const { refetch } = useGetHook({
    queryKey: ["vehicle-category"],
    url: `${APIS.VEHILCE_CATEGORY}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["vehicle-category"],
    navigateURL: "/vehicle-category",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.VEHILCE_CATEGORY}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Vehicle Category
        </span>
      </div>
      <EditVehicleCategoryComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
      />
    </>
  );
};
export default EditVehicleCategory;
